import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/tailwind.css";
import 'animate.css';

import 'vue-layer/lib/vue-layer.css';
import layer from 'vue-layer'
import {navigateTo} from '@/utils/util'

Vue.prototype.navigateTo = navigateTo

Vue.prototype.$layer = layer(Vue)
Vue.config.productionTip = false;

import Dialog from '@/components/dialog'
Vue.component('vDialog', Dialog)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
